module.exports = __webpack_public_path__ + "img/us3.a00e217d.png";